module.exports = __webpack_public_path__ + "cdfbe7bf660ac23b66aecd1556231f13.jpg";